function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M29.33 9.416a2.692 2.692 0 00-1.68-2.468l-9.325-3.82a6.092 6.092 0 00-4.65 0l-9.323 3.82A2.691 2.691 0 002.67 9.416c0 .008-.004.014-.004.02v13.122a2.682 2.682 0 001.685 2.492l9.325 3.827c1.49.61 3.16.608 4.65-.002l9.335-3.832a2.672 2.672 0 001.671-2.485V9.437c0-.008-.003-.014-.003-.02zM5.27 9.191l9.325-3.821c.9-.365 1.91-.365 2.809 0l9.325 3.82.001.001a.267.267 0 010 .505l-9.325 3.822a3.737 3.737 0 01-2.811 0L5.27 9.695a.267.267 0 010-.505h.001zm.016 13.622h-.001a.26.26 0 01-.194-.255V12.242l8.584 3.517v.002c.36.145.731.258 1.112.334V26.69c-.064-.022-9.502-3.878-9.502-3.878h.001zm21.442-.006s-9.451 3.861-9.516 3.884V16.095c.38-.076.752-.189 1.112-.334l8.584-3.519v10.316a.251.251 0 01-.181.25z"
});

function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRoom;